import React, { useState, useEffect , useRef} from 'react';
import PropTypes from 'prop-types';
import Map, { Marker, Popup, NavigationControl} from 'react-map-gl/maplibre';
import 'maplibre-gl/dist/maplibre-gl.css';
import { SelectButton } from 'primereact/selectbutton';

export const DashboardCriteriaMapContainer = ({onValueChange}) => {
    
    const [values, setValues] = useState([1,2]);

    const options = [
        {name: 'Projekty', icon: 'mdi mdi-home-city', value: 1, type:"PROJECT"},
        {name: 'Noclegi', icon: 'mdi mdi-bed', value: 2, type:"ACCOMMODATION"},
    ];

    const template = (option) => {
        return <div className='p-2'>{option.name} <i className={`${option.icon} ml-2`} style={{fontSize:"15px", marginLeft:"5px"}}></i></div> ;
    }
    
    const findTypesBySelectedValues = (selectedValues) => {
        return options
        .filter(option => selectedValues.includes(option.value))
        .map(option => option.type);
    }

    return (
        <div className="container-fluid mb-4 ps-0 dashboard-criteria">                   
            <SelectButton value={values} options={options} onChange={(e) => {
                const selectedValues = e.value; 
                const selectedTypes = findTypesBySelectedValues(selectedValues);
                onValueChange(selectedTypes)
                setValues(e.value)}} itemTemplate={template}  optionLabel="name" multiple />
        </div>  
    );
};

DashboardCriteriaMapContainer.defaultProps = {
};

DashboardCriteriaMapContainer.propTypes = {
    onValueChange: PropTypes.func.isRequired,
};

export default DashboardCriteriaMapContainer;
